import { render, staticRenderFns } from "./SuperBom.vue?vue&type=template&id=058a1f9a"
import script from "./SuperBom.vue?vue&type=script&lang=js"
export * from "./SuperBom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports